module.exports = __webpack_public_path__ + "04_mustache_silver.ac20dfd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/04_mustache_silver.png
// module id = AMXr
// module chunks = 0